import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { take } from 'rxjs';
import { InterviewSidebarComponent } from '../home/interview-sidebar/interview-sidebar.component';
import { UserClerkService } from './../../core/user/user-clerk.service';

@Component({
  selector: 'app-my-account',
  standalone: true,
  imports: [CommonModule, FormsModule, InterviewSidebarComponent],
  templateUrl: './my-account.component.html',
  styleUrl: './my-account.component.scss',
})
export class MyAccountComponent {
  constructor(private userClerkService: UserClerkService) {}

  @ViewChild('userProfile', { static: true })
  private clerkUserProfile?: ElementRef;

  ngAfterViewInit() {
    this.userClerkService
      .init$()
      .pipe(take(1))
      .subscribe(() => {
        this.userClerkService.mountUserProfile(this.clerkUserProfile!.nativeElement);
      });
  }
}
